/** Ids (como string, formato do filtro de rota) das unidades cuja classificação em `key` é `variant`. */
export function getUnitIdsByVariant<Unit extends { id: number }, Key extends keyof Unit>(
  units: readonly Unit[],
  key: Key,
  variant: Unit[Key],
): string[] {
  return units
    .filter((unit) => unit[key] === variant)
    .map((unit) => unit.id.toString());
}
